<template>
  <div class="part part_about">
    <div class="title">
      <img src="../../static/other/line.png" />
      <h2>应用简介</h2>
      <h2>APPLICATION INTRODUCTION</h2>
    </div>
    <el-row>
      <el-col :xs="24" :sm="12" class="about_left">
        <div class="wrap">
          {{ intro[0].content }}
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" class="about_right">
        <img :src="aboutImg[0].img" />
      </el-col>
    </el-row>
  </div>

</template>
<script>
  export default {
    name: 'Intro',
    data() {
      return {
        intro: [
          {
            title: "应用简介",
            content: "我们是一家专注致力于为广大用户提供便捷、专业、可靠的上门维修服务。平台汇聚了众多经验丰富的专业师傅，覆盖家电维修、电脑维修、汽车维修、管道疏通、水电安装、开锁换锁、家具组装等多个服务领域，让用户足不出户即可享受一站式生活维修服务。品牌名扶苏寓意生机勃勃、万物复苏，象征着我们帮助用户快速恢复家居生活品质的美好愿景。"

          }
        ],
        aboutImg: [
          {
            img: require('../../static/other/intro.jpg')
          }
        ]
      }
    }
  }
</script>

<style scoped>

  /* 公共 */
  .part {
    margin: 100px 0 200px 0;
  }

  .title {
    text-align: center;
    margin: 120px 0;
    color: #317bcb;
  }

  .about_left {
    padding: 0% 5% 5% 25%;
  }

  .about_left ul {
    list-style: none;
    padding-left: 0;
  }

  .about_left ul li {
    text-decoration: none;
    line-height: 2em;
  }

  .about_left li img {
    margin-right: 10px;
  }

  .about_right img {
    width: 60%;
  }

  /* 屏幕设备适配 max-device-width: 400px */
  @media screen and (max-device-width: 415px) {
    .part {
      margin: 50px 0;
    }

    .title {
      margin: 0;
    }

    .about_left {
      padding: 5% 15% 5% 15%;
    }

    .about_right img {
      width: 90% !important;
      margin-left: 5%;
    }
  }
</style>